module.exports = require('./helpers/bundle-url').getBundleURL('9G649') + "light-mode.9ae6186d.svg";